/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { utils } from 'pixi.js-legacy';

import { FancySprite } from '@appCanvasCommon/graphics/FancySprite';

import { INSERTION_POINT_TEXTURES } from './InsertionPointConfiguration';

interface InsertionPointRectangleConfiguration {
	height: number;
	tint: number;
	width: number;
}

interface InsertionPointRectangleUpdatableConfiguration {
	width: number;
}

/**
 * This class draws a rectangle sprite on the screen.
 */
export class InsertionPointRectangle extends FancySprite {
	constructor(configuration: InsertionPointRectangleConfiguration) {
		super(utils.TextureCache[INSERTION_POINT_TEXTURES.INSERTION_POINT_RECTANGLE]);
		this.init(configuration);
	}

	public override destroy(): void {
		super.destroy();
	}

	public update(configuration: InsertionPointRectangleUpdatableConfiguration): void {
		this.width = configuration.width;
	}

	private init(initialConfiguration: InsertionPointRectangleConfiguration): void {
		// Static configuration
		this.visible = true;
		// Dynamic configuration
		this.height = initialConfiguration.height;
		this.tint = initialConfiguration.tint;
		// Updatable configuration
		this.width = initialConfiguration.width;
	}
}
